module.exports = __webpack_public_path__ + "static/media/heart-my-icon.2fec3032.svg";